import { stringUtils } from "@/utils";
import { size } from "lodash";

export const getTopProductsColumns = (t: (text: string) => string) => {
  return [
    {
      header: stringUtils.capitalizeFirstLetter(t("product_name")),
      accessorKey: "name",
      minSize: 300,
    },
    {
      header: stringUtils.capitalizeFirstLetter(t("displays")),
      accessorKey: "displays",
    },
    {
      header: stringUtils.capitalizeFirstLetter(t("click_through_rate")),
      accessorKey: "clickThroughRate",
    },
    {
      header: stringUtils.capitalizeFirstLetter(t("add_to_cart_rate")),
      accessorKey: "addToCartRate",
    },
    {
      header: stringUtils.capitalizeFirstLetter(t("revenue")),
      accessorKey: "revenue",
    },
  ];
};
